import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, Button } from "@mui/material";
import Cookies from "js-cookie";

const ZoneDropdown = ({ field, zones, setSelectedZone, disabled }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const isDropdownOpen = Boolean(anchorEl);
  console.log(zones)

  // Function to toggle the dropdown visibility
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Handle clicking on a zone and navigating to its details
  const handleZoneClick = (zone) => {
    setSelectedZone(zone);
    Cookies.set('active_zone_id', zone.id);
    navigate(`../field/${field.name}/zone/${zone.id}`);
    handleClose();
  };

  

  return (
    <div>
      <Button
        variant="contained"
        disabled={disabled}
        onClick={handleClick}
        aria-controls={isDropdownOpen ? "zone-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen ? "true" : undefined}
        sx={{
          backgroundColor: "green",
          color: "white",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "darkgreen",
          },
        }}
      >
        Select Zone
      </Button>
      <Menu
        id="zone-menu"
        anchorEl={anchorEl}
        open={isDropdownOpen}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "zone-button",
        }}
      >
        {zones.map((zone) => (
          <MenuItem key={zone.id} onClick={() => handleZoneClick(zone) }>
            {zone.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ZoneDropdown;
